<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let actionType: "increment" | "decrement";
  export let containerType: string;
  export let disabled: boolean = false;
  export let inventoryId: number;

  const buttonText = actionType === "increment" ? "+" : "-";

  const dispatch = createEventDispatcher();

  function emitUpdateQuantity() {
    dispatch(actionType);
  }
</script>

<style>
  .cart-widget-button {
    font-size: 22px;
    padding: 0.25rem 0.75rem;
    width: 40px;
  }

  .cart-widget-button:hover {
    border-color: #008fbe;
    color: #008fbe;
  }
</style>

<button
  data-testid={`cart-widget-button-${actionType}-${containerType}-${inventoryId}`}
  class="cart-widget-button fizz-text-strong fizz-button fizz-bordered fizz-radius-medium fizz-text-center"
  {disabled}
  on:click={emitUpdateQuantity}
>
  {buttonText}
</button>
